import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signup } from "../../firebase/auth";
import GoogleSignInButton from "../../components/GoogleSignInButton/GoogleSignInButton";

export default function Signup() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect") || "/";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            await signup(email, password, name);
            navigate(redirect);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full bg-white p-8 shadow rounded-lg">
                <h1 className="text-xl font-bold mb-6 text-center">Sign Up</h1>
                {error && <p className="text-red-500 mb-4 text-center">{error}</p>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Name"
                        className="w-full border border-surface rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        required
                    />
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        className="w-full border border-surface rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        required
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        className="w-full border border-surface rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                        required
                    />
                    <p className="text-sm mt-1">
                        Password must include at least 8 characters, one uppercase letter, one number, and one special character.
                    </p>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-primary text-text-light py-2 rounded hover:bg-secondary transition-colors"
                    >
                        {loading ? "Signing up..." : "Sign Up"}
                    </button>
                </form>

                <div className="flex items-center my-4">
                    <hr className="flex-grow border-surface" />
                    <span className="mx-2">or</span>
                    <hr className="flex-grow border-surface" />
                </div>

                <GoogleSignInButton redirect={redirect} />

                <p className="mt-4 text-center">
                    Already have an account?{" "}
                    <a
                        href={`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ""}`}
                        className="text-blue-500 hover:underline"
                    >
                        Login
                    </a>
                </p>
            </div>
        </div>
    );
}
